module.exports = __webpack_public_path__ + "static/media/suitability-score-icon2.617e1335.svg";